"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var IsLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(IsLogin, _super);
    function IsLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '核销端验证是否登录';
        _this.code = '300005';
        _this.desc = '核销端验证是否登录';
        _this.requestParams = new coupon_1.IsLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return IsLogin;
}(service_1.BaseService));
exports.IsLogin = IsLogin;
//# sourceMappingURL=isLogin.js.map